var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bet-info-wrapper",
      class: { "bet-info": !_vm.notifications.length },
    },
    [
      !_vm.notifications.length
        ? _c("div", { staticClass: "bet-area" }, [
            !_vm.player.loggedIn && !_vm.bet.outcomes.length
              ? _c("div", { staticClass: "bet-info-message" }, [
                  _vm._m(0),
                  _c("div", { staticClass: "message-text" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("translate")("general_ticket_login_message")
                        ) +
                        " "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.player.loggedIn &&
            !_vm.bet.outcomes.length &&
            !_vm.ticket.bets.length
              ? _c("div", { staticClass: "bet-info-message" }, [
                  _vm._m(1),
                  _c("div", { staticClass: "message-text" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("translate")("general_ticket_empty_message")
                        ) +
                        " "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.player.loggedIn &&
            !_vm.bet.outcomes.length &&
            _vm.ticket.bets.length
              ? _c("div", { staticClass: "bet-info-message" }, [
                  _vm._m(2),
                  _c("div", { staticClass: "message-text" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("translate")("general_check_and_payin_message")
                        ) +
                        " "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.betInfo.title && _vm.betInfo.title.length
              ? _c("div", { staticClass: "bet-item-details" }, [
                  _c("span", { staticClass: "bet-type" }, [
                    _vm._v(_vm._s(_vm.betInfo.subtitle)),
                  ]),
                  _c(
                    "div",
                    _vm._l(_vm.betInfo.title, function (value, index) {
                      return _c("span", { key: index, staticClass: "value" }, [
                        _vm._v(
                          " " + _vm._s(_vm.formatTitle(value.title)) + " "
                        ),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm.bet && _vm.bet.outcomes.length
              ? _c(
                  "div",
                  {
                    staticClass: "remove-bet",
                    on: { click: _vm.clearSelection },
                  },
                  [_c("i", { staticClass: "icon icon-close-a" })]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.notifications.length
        ? _c(
            "div",
            { staticClass: "notification-area", class: { wide: true } },
            _vm._l(_vm.notifications, function (item, key) {
              return _c(
                "div",
                { key: key, staticClass: "item", class: item.status },
                [
                  _c("div", { staticClass: "item-icon" }, [
                    _c("i", {
                      staticClass: "icon",
                      class: "icon-" + item.icon,
                    }),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "item-title",
                      attrs: { title: "" + item.message },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm._f("translate")(item.message)) + " "
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "message-icon" }, [
      _c("i", { staticClass: "icon icon-info" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "message-icon" }, [
      _c("i", { staticClass: "icon icon-info" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "message-icon" }, [
      _c("i", { staticClass: "icon icon-info" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }